/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Agvertragsinfos2Inputs */



/**

* @param {_Field_Agvertragsinfos2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_agvertragsinfos2 = /** @type {((inputs?: _Field_Agvertragsinfos2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Agvertragsinfos2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("AG-Vertragsinfos")
});
export { _field_agvertragsinfos2 as "_field_agVertragsInfos" }